<template>
	<div class="official-recommend-page">
		<div class="title">
			心愿单列表
		</div>
		<div class="officialList" v-if="wishData.length">
			<div class="offical-container" v-for="(item,index) in wishData" :key="index"
				@click="$router.push({path: '/work-details',query: {id:item.id,userId: item.user_id,type: 3}})">
				<img class="bestIcon" src="../assets/Home/best.png" v-if="item.shuxing && item.shuxing == '精品图'" />
				<div class="likeNum">
					<img class="likeNumIcon" src="../assets/WorkDetails/iconL.png" />
					<span>{{item.zan_count}}</span>
				</div>
				<img class="likeIcon" :src="item.img" />
				<div class="likeTitle ellipsis-1">{{item.title}}</div>
				<div class="likeDesc ellipsis-2">
					{{item.content}}
				</div>
				<div class="tips">
					<div class="tip" v-if="item.cid">
						{{item.cid}}
					</div>
					<div class="tip ellipsis-1" v-for="(row,rowIndex) in item.yongtu.slice(0,1)" :key="rowIndex">
						{{row}}
					</div>
				</div>
				<div class="buyNow" @click.stop="changeCollection(item)">
					<img class="icon" src="../assets/WorkDetails/iconQ.png" alt="" />
					已加入心愿单
				</div>
			</div>
		</div>
		<el-empty description="暂无数据" v-else></el-empty>
		<PagePagination v-if="wishData.length" :pageSize="8" style="padding: .32rem 0 0;" :currentPage="currentPage"
			:total="total" @current-change="onPageChange" />
	</div>
</template>

<script>
	export default {
		name: 'WishlistList',
		data() {
			return {
				currentPage: 1, // 当前页码
				total: 1, // 总条数
				wishData: [],
			}
		},
		methods: {
			onPageChange(newPage) {
				this.currentPage = newPage
				this.wishList()
			},
			wishList() {
				this.$api.post('Hua/user_hua_list', {
					p: this.currentPage
				}).then(res => {
					if (res.code == 1) {
						this.total = res.data.count
						this.wishData = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
			},
			changeCollection(item) {
				this.$api.post('/Hua/sc_work', {
					id: item.id
				}).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg)
						this.wishList()
					}
				}).catch(err => {
					console.log(err);
				})
			}
		},
		mounted() {
			this.wishList()
		}
	}
</script>

<style lang="scss" scoped>
	.official-recommend-page {
		width: 100%;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		padding: .32rem .4rem;
	}

	.content-container {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: .32rem .4rem;
	}

	.title {
		font-weight: 600;
		font-size: .16rem;
		color: #333333;
	}

	.officialList {
		width: 100%;
		display: flex;
		flex-wrap: wrap;

		.offical-container {
			margin-top: .24rem;
			display: flex;
			flex-direction: column;
			margin-right: .24rem;
			position: relative;
			cursor: pointer;

			.bestIcon {
				position: absolute;
				top: 0;
				left: 0;
				width: .67rem;
				height: .67rem;
			}

			.likeNum {
				position: absolute;
				top: .16rem;
				right: .16rem;
				height: .24rem;
				display: flex;
				align-items: center;
				padding: 0 .1rem;
				background: rgba(255, 255, 255, .9);
				box-shadow: 0px 2px 15px 0px rgba(176, 176, 176, 0.6);
				border-radius: 12px;
				font-weight: 500;
				font-size: .14rem;
				color: #333333;

				.likeNumIcon {
					margin-right: .02rem;
					width: .15rem;
					height: .14rem;
				}

				span {
					margin-top: .02rem;
				}
			}

			.likeIcon {
				width: 2.05rem;
				height: 2.76rem;
				object-fit: cover;
				border-radius: .08rem;
			}

			.likeTitle {
				width: 2.05rem;
				margin-top: .24rem;
				font-weight: 600;
				font-size: .24rem;
				color: #000000;
				line-height: .32rem;
			}

			.likeDesc {
				height: .4rem;
				width: 2.05rem;
				margin-top: .06rem;
				font-weight: 400;
				font-size: .14rem;
				color: #333333;
				line-height: .2rem;
			}

			.tips {
				margin-top: .12rem;
				width: 2.05rem;
				display: flex;
				align-items: center;
				overflow: hidden;

				.tip {
					height: .26rem;
					margin-right: .12rem;
					padding: 0 .08rem;
					font-weight: 400;
					font-size: .12rem;
					color: #7C3E0B;
					line-height: .24rem;
					border-radius: .13rem;
					border: .01rem solid #A88653;
				}
			}

			.buyNow {
				margin: .16rem auto 0;
				width: 1.9rem;
				height: .4rem;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: .04rem;
				border: .01rem solid #CCCCCC;
				font-weight: 400;
				font-size: .12rem;
				color: #999999;
				cursor: pointer;

				.icon {
					width: .16rem;
					height: .16rem;
					margin-right: .06rem;
				}
			}
		}
	}
</style>